export default __webpack_public_path__ + "static/media/edit.20b68f00.svg";